// extracted by mini-css-extract-plugin
export default {"team":"AboutPage_team__eVNcA"};